module.exports = __webpack_public_path__ + "img/Weapon_192.d99bbb59.png";